import React from 'react';
import { Result, Button, Space } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { HomeOutlined, ArrowLeftOutlined, FrownOutlined } from '@ant-design/icons';
import { routes } from '../utils/routes.config';
import { useSelector } from 'react-redux';
import MainLayout from './MainLayout';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userDetail = useSelector((state: any) => state.UserData.userData);
  const isAuthenticated = userDetail?.role ? true : false;
  const isSuperAdmin = userDetail?.role === "superAdmin";

  const handleGoHome = () => {
    if (isAuthenticated) {
      navigate(isSuperAdmin ? routes.SUPER_DASHBOARD : routes.DASHBOARD);
    } else {
      navigate(routes.HOME);
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

    return (
    <div className="not-found-container">
      {isAuthenticated ? (
        <MainLayout>
          <div className="not-found-content">
            <Result
              status="404"
              icon={<FrownOutlined style={{ fontSize: 72, color: '#667eea' }} />}
              title="404"
              subTitle="Sorry, the page you visited does not exist."
              extra={
                <Space size="large">
                  <Button
                    type="primary"
                    icon={<HomeOutlined />}
                    onClick={handleGoHome}
                    size="large"
                  >
                    Go to Dashboard
                  </Button>
                  <Button
                    icon={<ArrowLeftOutlined />}
                    onClick={handleGoBack}
                    size="large"
                  >
                    Go Back
                  </Button>
                </Space>
              }
            />
            <div className="not-found-details">
              <p className="not-found-path">Path: <code>{location.pathname}</code></p>
            </div>
          </div>
        </MainLayout>
      ) : (
        <div className="not-found-page">
          <div className="not-found-background">
            <div className="not-found-background-pattern"></div>
            <div className="not-found-background-gradient"></div>
          </div>
          
          <div className="not-found-content-public">
            <div className="not-found-icon-wrapper">
              <FrownOutlined className="not-found-icon" />
            </div>
            <h1 className="not-found-title">404</h1>
            <h2 className="not-found-subtitle">Page Not Found</h2>
            <p className="not-found-description">
              Oops! The page you're looking for doesn't exist or has been moved.
            </p>
            <Space size="large">
              <Button
                type="primary"
                icon={<HomeOutlined />}
                onClick={handleGoHome}
                size="large"
                className="not-found-button"
              >
                Go to Home
              </Button>
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={handleGoBack}
                size="large"
                className="not-found-button-secondary"
              >
                Go Back
              </Button>
            </Space>
            <div className="not-found-path-info">
              <p>Path: <code>{location.pathname}</code></p>
            </div>
          </div>
        </div>
      )}
        </div>
    );
};

export default NotFound;
